import React, { useState } from "react";
import Image from "next/image";

const UspSolutionDesktop = () => {
  const [isPopupOpen, setPopupOpen] = useState({ open: false, code: "" });

  const openPopup = (code: string) => {
    setPopupOpen({ open: true, code: code });
  };

  const closePopup = () => {
    setPopupOpen({ open: false, code: "" });
  };

  return (
    <>
      <div className="w-full md:pt-[50px] pt-[32px] md:pb-[50px] pb-[32px] bg-[#0C1F33] relative">
        <Image
          src="/images/accounting/usp/solution-mount.png"
          alt="Special Offer"
          className="md:block hidden mx-auto absolute md:bottom-0 bottom-0 left-0 z-[-1] md:w-[650px]"
          width={920}
          height={630}
          priority
        />
        <div className="lg:container mx-auto 2xl:px-0 xl:px-10 lg:p-0">
          <div className="text-center">
            <h2 className="text-2xl lg:text-[36px] md:text-[36px] mb-3 font-semibold lg:leading-[3.5rem] md:leading-[3rem] leading-[1.8rem] text-white text-center inline-block mx-auto px-[4px]">
              Here’
              <span className="md:pb-0 inline-block border-[#ca7216] md:border-b-[4px] border-b-2">
                s Our Solution: US STEM Pathway for Global Accou
              </span>
              ntants
            </h2>
            <p className="text-[30px] md:text-[24px] leading-[36px] text-[#D6D4D4] font-semibold text-center tracking-[-3%] pt-[10px] pb-[35px]">
              For decades, the <span className="text-[#ca7216]">STEM</span>{" "}
              track has been used by Techies to work in the US
            </p>
          </div>

          <div className="flex justify-center items-center">
            <div className="w-[54%] md:ml-[6%]">
              <div className="flex md:w-[543px] items-start gap-[15px] border-[2px] border-[#0C3D6F] img-shadow rounded-[14px] px-[15px] py-[20px] playbook">
                <Image
                  src="/images/accounting/usp/playbook-new.svg"
                  alt="Accountants"
                  className="mt-[5px] md:w-[40px] md:h-[40px]"
                  width={60}
                  height={60}
                />
                <p className="text-[24px] md:text-[16px] leading-[20px] text-white font-normal">
                  Miles has used the same playbook
                  <br />
                  to recruit{" "}
                  <span className="text-[#CA7216]">1000s of Accountants</span>
                  <br />
                  to work in the US
                </p>
              </div>

              <div className="playbook md:w-[543px] md:h-[105px]  border-[2px] border-[#0C3D6F] img-shadow rounded-[14px] px-[15px] py-[20px] mt-[20px]">
                <div className="flex items-center justify-center gap-[15px]">
                  <p className="text-[#fff] text-[18px] md:text-[14px] leading-[20px] font-semibold">
                    Traditional Master’s in <br />
                    Accounting Program
                    <br /> (Non-STEM)
                  </p>

                  <p className="text-[40px] leading-[50px] font-bold text-white">
                    +
                  </p>
                  <p className="text-[#fff] text-[14px] leading-[20px] font-semibold">
                    Data Analytics & <br />
                    Information Systems
                  </p>
                  <p className="text-[40px] leading-[50px] font-bold text-white">
                    =
                  </p>
                  <p className="text-[#fff] text-[14px] leading-[20px] font-semibold">
                    MS in Accounting <br />
                    (STEM)
                  </p>
                </div>
              </div>
            </div>
            <div className="w-[46%] md:mr-[6%]">
              <div
                className="video-gif relative rounded-[14px]"
                onClick={() => {
                  openPopup("VWzM-bqssTk");
                }}
              >
                <Image
                  src="/images/accounting/usp/miles-path.gif"
                  alt="Accountants"
                  className="cursor-pointer w-full rounded-[14px]"
                  width={500}
                  height={281}
                />

                <div className="flex items-center justify-center md:rounded-[15px] rounded-[15px] absolute left-0 right-0 bottom-[40%]">
                  <Image
                    src="/images/accounting/usp/video-icon.png"
                    alt="Accountants "
                    className="cursor-pointer w-[70px]"
                    width={110}
                    height={110}
                  />
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      {isPopupOpen.open && (
        <div className="fixed inset-0 bg-black bg-opacity-50 flex justify-center items-center z-[999]">
          <div className="bg-white p-1 shadow-lg relative rounded-[14px] md:w-[auto] w-[85%]">
            <button
              onClick={closePopup}
              className="mt-4 bg-red-700 text-white px-3 py-1 rounded absolute right-[-15px] top-[-30px]"
            >
              ✕
            </button>
            <iframe
              className="lg:w-[600px] md:w-[500px] md:h-[280px] rounded-[14px] lg:h-[320px] h-[220px]"
              width="100%"
              height="320"
              src={`https://www.youtube.com/embed/${isPopupOpen.code}`}
              title="YouTube video player"
              allow="accelerometer; autoplay; climd:oard- pb-14write; encrypted-media; gyroscope; picture-in-picture; web-share"
            ></iframe>
          </div>
        </div>
      )}
    </>
  );
};

export default UspSolutionDesktop;
